import api from './api';
import {
  Package,
  CreatePackageRequest,
  UpdatePackageRequest,
  ApiResponse,
} from '../types/package';

export const packageService = {
  /**
   * Get all packages
   */
  async getAll(): Promise<ApiResponse<Package[]>> {
    const { data } = await api.get<ApiResponse<Package[]>>('/api/v1/packages');
    return data;
  },

  /**
   * Get package by ID
   */
  async getById(id: string): Promise<ApiResponse<Package>> {
    const { data } = await api.get<ApiResponse<Package>>(`/api/v1/packages/${id}`);
    return data;
  },

  /**
   * Create a new package
   */
  async create(request: CreatePackageRequest): Promise<ApiResponse<Package>> {
    const { data } = await api.post<ApiResponse<Package>>('/api/v1/packages', request);
    return data;
  },

  /**
   * Update package
   */
  async update(id: string, request: UpdatePackageRequest): Promise<ApiResponse<Package>> {
    const { data } = await api.put<ApiResponse<Package>>(`/api/v1/packages/${id}`, request);
    return data;
  },

  /**
   * Delete package
   */
  async delete(id: string): Promise<ApiResponse<null>> {
    const { data } = await api.delete<ApiResponse<null>>(`/api/v1/packages/${id}`);
    return data;
  },

  /**
   * Toggle package active status
   */
  async toggleActive(id: string, isActive: boolean): Promise<ApiResponse<Package>> {
    return this.update(id, { isActive });
  },
};
